<div class="d-flex flex-wrap">
  @if (selected.length === items.length) {
    <!-- All items selected -->
    <div class="ng-value">
      <span class="ng-value-label">{{ allLabel + ' (' + selected.length + ')' }}</span>
    </div>
  } @else {
    @for (item of selected | slice: 0 : max; track item) {
      <!-- N first items -->
      <div class="ng-value">
        <span class="ng-value-label">{{ item[bindLabel] }}</span>
      </div>
    }
    @if (selected.length > max) {
      <!-- Counter -->
      <div class="ng-value">
        <span class="ng-value-label">+{{ selected.length - max }}</span>
      </div>
    }
  }
</div>
